import '../sass/su2019.scss';
import './polyfills';
import '@babel/polyfill';
import 'whatwg-fetch';

import { onPageReady } from './utils';

import mobileMenu from './modules/mobile.menu.js';
import shareWidget from './modules/share.widget.js';
import dropdown from './modules/dropdown';
import externaliseLinks from './utils/externaliseLinks';

const config = Object.assign({
  header: '.page__header',
  mobileMenu: '.mobile-menu',
  mobileMenuTrigger: '.mobile-menu-toggle',
  theme: 'su_2019',
}, window.APP_CONFIG);


function initialise() {
  window.THEME = config.theme;

  externaliseLinks();
  mobileMenu.init(config);
  shareWidget.init(config);
  dropdown.init();

  if (document.querySelectorAll('[data-reoako-id]')) {
    import('./modules/reoako.js')
        .then(({ default: reoakoInit }) => {
            reoakoInit();
        });
  }

  if (document.querySelector('[data-video]')) {
    import(/* webpackChunkName: "video" */ './modules/video.js')
      .then(({ default: video }) => {
        video.init();
      }).catch(err => {
        console.log(err);
      });
  }
}

/* Initialise app */
onPageReady(initialise);
